<template>
    <div>

        <vue-headful title="Training Courses :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses`">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </router-link>
                </li>
                <li class="breadcrumb-item active"><i class="fa fa-check-square"></i> Completed Courses</li>
            </ol>
        </h4>

        <saved-filter-title :filterKey="'empCourseFilters'" />

        <div class="card">
            <div class="card-body">
                <employee-training-list ref="empCompletedList" :saveState="true" :allowFilterSaving="true" :filterId="(filter_id ? parseInt(filter_id) : null)" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filter_id: this.$route.query.filter_id,
            }
        },

        methods: {

        },

        mounted(){
            //Focus on the SEarch Input
            this.$refs.empCompletedList.$refs.empTrainingCourseTable.$refs.genericFilter.focus();
        },
    }
</script>
